var _title, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcoPaymethodApple = function SvgIcoPaymethodApple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (/*#__PURE__*/React.createElement("svg", _extends({
      id: "Layer_1",
      "data-name": "Layer 1",
      viewBox: "0 0 24 24",
      ref: svgRef
    }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ico_paymethod_apple")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
      id: "path4",
      d: "M20.62,16.65a10.9,10.9,0,0,1-1.15,2.07A10,10,0,0,1,18,20.51a2.9,2.9,0,0,1-1.9.84,4.86,4.86,0,0,1-1.76-.42,5,5,0,0,0-1.89-.42,5.19,5.19,0,0,0-1.94.42,5.48,5.48,0,0,1-1.68.44,2.72,2.72,0,0,1-1.95-.86,11.38,11.38,0,0,1-1.55-1.85A12.75,12.75,0,0,1,3.69,15.4,11.81,11.81,0,0,1,3,11.53a7.06,7.06,0,0,1,.93-3.7,5.42,5.42,0,0,1,1.95-2,5.17,5.17,0,0,1,2.63-.74,6.28,6.28,0,0,1,2,.47,6.66,6.66,0,0,0,1.62.47A9.32,9.32,0,0,0,14,5.5a6.11,6.11,0,0,1,2.43-.43A5.2,5.2,0,0,1,20.43,7.2,4.5,4.5,0,0,0,18,11.29a4.49,4.49,0,0,0,1.48,3.4,4.8,4.8,0,0,0,1.48,1c-.12.35-.24.68-.38,1ZM16.5.43a4.56,4.56,0,0,1-1.17,3A4,4,0,0,1,12,5.05c0-.13,0-.26,0-.4A4.85,4.85,0,0,1,14.75.49,4.46,4.46,0,0,1,16.48,0c0,.14,0,.29,0,.43Z"
    })))
  );
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return (/*#__PURE__*/React.createElement(SvgIcoPaymethodApple, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/ico_paymethod_apple.62a13d27.svg";
export { ForwardRef as ReactComponent };